import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface StatProps {
  value: string;
  label: string;
  subtext: string;
  delay: number;
}
const StatCard = ({
  value,
  label,
  subtext,
  delay
}: StatProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 20
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100 flex flex-col items-center text-center h-full hover:shadow-2xl transition-shadow duration-300" data-id="element-178">
      <div className="text-5xl md:text-6xl font-extrabold text-emerald-500 mb-4 tracking-tight" data-id="element-179">
        {value}
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-180">{label}</h3>
      <p className="text-slate-500 text-sm font-medium" data-id="element-181">{subtext}</p>
    </motion.div>;
};
export function ResultsSection() {
  return <section className="py-20 bg-slate-50 relative -mt-20 z-20" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-184">
          <StatCard value="39.75%" label="Conversion Rate" subtext="vs 22.3% industry average" delay={0} data-id="element-185" />
          <StatCard value="$41.87" label="Cost Per Lead" subtext="19% lower than top competitor" delay={0.1} data-id="element-186" />
          <StatCard value="120+" label="Leads Generated" subtext="Last 30 days (as of 01/26)" delay={0.2} data-id="element-187" />
          <StatCard value="6" label="Month Partnership" subtext="Ongoing optimization and growth" delay={0.3} data-id="element-188" />
        </div>
      </div>
    </section>;
}